import {createHttpDataApi, createMockDataApi, IDataApi} from '../fetchers';
import {QueryParameters} from '../types';
import {ApiFactoryConfig} from './types';

export const createByIdApiFactory = <
  TData extends Record<TIdKey, any>,
  TIdKey extends keyof TData = keyof TData,
  // eslint-disable-next-line @typescript-eslint/ban-types
  TParameters extends QueryParameters = {},
  // eslint-disable-next-line @typescript-eslint/ban-types
  TPayload = {}
>(
  config: ApiFactoryConfig<TData, TIdKey, TParameters, TPayload>,
): IDataApi<TData, TIdKey, TParameters, TPayload> => {
  if (config.mode === 'mock') {
    return createMockDataApi<TData, TIdKey, TParameters, TPayload>(
      config.idKey,
      config.mockData,
      config.mockIdFactory,
      config.mockFactory as (id: string, payload: TPayload) => TData,
      config.mockFailureRate,
    );
  } else {
    return createHttpDataApi<TData, TIdKey, TParameters, TPayload>(config);
  }
};
